<template>
  <div class="card-container mb-16">
    <div class="card-title mb-16">{{ title }}</div>
    <div class="card-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InfoCard',
    props: {
      title: {
        type: [String, Number],
        default: ''
      }
    }
  }
</script>

<style lang="less" scoped>
.card-container {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  .card-title {
    font-weight: bold;
    font-size: 16px;
    color: #4d4e4e;
  }
  .card-content {
    width: 100%;
    overflow: hidden;
  }
  .info-row {
    display: flex;
    line-height: 26px;
    margin-bottom: 8px;
    .label {
      width: 100px;
      color: #929a9f;
      flex-shrink: 0;
    }
    .value {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
  }
}
.mb-16 {
  margin-bottom: 16px;
}
</style>